import { Helmet } from "react-helmet-async";
import {
  HOME_INTRO_VIDEO_MEDIA,
  HOME_INTRO_VIDEOS,
} from "../../../../constants/media";

type HomeHeroPreloadProps = {
  posterSrc: string;
};

const HomeHeroPreload = ({ posterSrc }: HomeHeroPreloadProps) => (
  <Helmet prioritizeSeoTags>
    <link rel="preload" as="image" href={posterSrc} />
    <link
      rel="preload"
      as="video"
      type="video/mp4"
      href={HOME_INTRO_VIDEOS.mobile}
      media={HOME_INTRO_VIDEO_MEDIA.mobile}
    />
    <link
      rel="preload"
      as="video"
      type="video/mp4"
      href={HOME_INTRO_VIDEOS.desktop}
      media={HOME_INTRO_VIDEO_MEDIA.desktop}
    />
  </Helmet>
);

export default HomeHeroPreload;
